var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationActiveNotch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 10,
    viewBox: "0 0 36 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 17",
    d: "M36 10L19.8598 0.502945C18.7201 -0.167647 17.2798 -0.167649 16.1402 0.502944L0 9.99999L36 10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationActiveNotch);
export default __webpack_public_path__ + "static/media/navigation-active-notch.f7c219231b1d3872d7a56877a4c243e2.svg";
export { ForwardRef as ReactComponent };